import { Body, TextLink } from '@assembly-js/design-system';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import { AUTH_STATES } from 'src/constants/authConsts';
import { PRIVACY_POLICY_LINK, TOS_LINK } from 'src/constants/externalUrls';
import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { AuthLinkActionButton } from 'src/legacy/components/Auth/AuthLinkActionButton';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { GraySmall } from 'src/theme/colors';

const useStyles = makeStyles()((theme) => ({
  loginActionsWrapper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  actionsWrapper: {
    marginTop: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
  },
  centerWrapper: {
    margin: 'auto',
    maxWidth: '340px',
  },
  link: {
    color: GraySmall,
    fontSize: 14,
    fontWeight: 500,
  },
  note: {
    color: GraySmall,
  },
  alreadyHaveAccountLink: {
    marginTop: theme.spacing(2.5),
    color: GraySmall,
  },
  alreadyHaveAccountLinkSpacing: {
    marginTop: theme.spacing(1),
  },
  loginWrapperSpacing: {
    marginTop: theme.spacing(2.5),
  },
}));

interface OnboardingLoginFormFooterActionsProps {
  showOnboardingLoginActions: boolean;
  hidePolicy?: boolean;
}
export const OnboardingLoginFormFooterActions: React.FC<
  OnboardingLoginFormFooterActionsProps
> = ({ showOnboardingLoginActions, hidePolicy = false }) => {
  const { classes, cx } = useStyles();
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();

  return (
    <>
      {showOnboardingLoginActions ? (
        <div
          className={cx(
            classes.loginActionsWrapper,
            classes.loginWrapperSpacing,
          )}
        >
          <AuthLinkActionButton
            href={
              `?` +
              new URLSearchParams({
                step: AUTH_STATES.FORGOT_PASSWORD,
              }).toString()
            }
          >
            {isAssemblyBrandEnabled ? (
              <strong>{'Forgot password?'}</strong>
            ) : (
              'Forgot password?'
            )}
          </AuthLinkActionButton>
          <AuthLinkActionButton href="/signup">
            {isAssemblyBrandEnabled ? (
              <strong>{"Don't have an account?"}</strong>
            ) : (
              "Don't have an account?"
            )}
          </AuthLinkActionButton>
        </div>
      ) : (
        <div
          className={classNames(classes.actionsWrapper, {
            'mt-[53px]': !isAssemblyBrandEnabled,
            'mt-8': isAssemblyBrandEnabled,
          })}
        >
          <div className={classes.centerWrapper}>
            {!hidePolicy && (
              <BaseTypography
                fontType="13Regular"
                align="center"
                className={classes.note}
              >
                You acknowledge that you read, and agree to our
                <TextLink
                  href={TOS_LINK}
                  target="_blank"
                  className="inline-flex text-gray-small"
                  variant="minimal"
                >
                  {isAssemblyBrandEnabled ? (
                    <strong>Terms of Service</strong>
                  ) : (
                    'Terms of Service'
                  )}
                </TextLink>
                &nbsp;and our&nbsp;
                <TextLink
                  href={PRIVACY_POLICY_LINK}
                  target="_blank"
                  className="inline-flex text-gray-small"
                  variant="minimal"
                >
                  {isAssemblyBrandEnabled ? (
                    <strong>Privacy Policy</strong>
                  ) : (
                    'Privacy Policy'
                  )}
                </TextLink>
                .
              </BaseTypography>
            )}
            <TextLink
              variant="minimal"
              className="mx-auto mt-2"
              href="/login"
              target="_self"
            >
              <Body size="sm">
                {isAssemblyBrandEnabled ? (
                  <strong>Already have an account?</strong>
                ) : (
                  'Already have an account?'
                )}
              </Body>
            </TextLink>
          </div>
        </div>
      )}
    </>
  );
};
